import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import Text from '@components/Text'
import Button from '@components/Button'
import ButtonWithLoader from '@components/ButtonWithLoader'
import {
  COLORS,
  DIVIDER_SIZE,
  BUTTON_TYPE,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import Icon from '@components/Icon'
import { getFormattedPercent } from '@helpers/exams'

const ValidateQuizExamAnswers = (props) => {
  const {
    score,
    passingPercentage,
    questions,
    retryExam,
    isRetrying,
    reviewQuestions,
    closePanel,
  } = props

  const percent = (score * 100) / questions.length
  const passed = percent >= passingPercentage

  // "Gör om test" is only offered after a failed attempt, and only when the
  // parent says there are attempts left (retryExam is then provided)
  const showRetry = !passed && typeof retryExam === 'function'

  return (
    <div className={'flex flex-col items-center'}>
      <Divider size={DIVIDER_SIZE.BASE} />

      {/* <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
        Du fick {score} rätt av {questions.length}
      </Heading>
      <Divider size={DIVIDER_SIZE.SMALL} /> */}

      {passed ? (
        // --- User passed
        <>
          <Icon icon='ExamPassedCheckmark' />
          <Divider size={DIVIDER_SIZE.SMALL} />
          <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
            Godkänt!
          </Heading>
        </>
      ) : (
        // --- User failed
        <>
          <Icon icon='ExamFailedCross' />
          <Divider size={DIVIDER_SIZE.SMALL} />
          <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
            Ej godkänt
          </Heading>
        </>
      )}

      <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XXXLARGE}>
        {getFormattedPercent(score, questions.length)}
      </Heading>

      <Divider size={DIVIDER_SIZE.BASE} />

      <div className={'flex flex-wrap justify-center'}>
        {showRetry && (
          <ButtonWithLoader
            type={BUTTON_TYPE.PRIMARY}
            isLoading={isRetrying}
            disabled={isRetrying}
            enabledText={'Gör om test'}
            disabledText={'Gör om test'}
            handleClick={retryExam}
            margin
          />
        )}

        <Button
          type={BUTTON_TYPE.PRIMARY}
          handleClick={() => {
            reviewQuestions()
          }}
          margin
        >
          Se svar
        </Button>

        <Button type={BUTTON_TYPE.PRIMARY} handleClick={closePanel} margin>
          Stäng
        </Button>
      </div>

      <Divider size={DIVIDER_SIZE.SMALL} />
    </div>
  )
}

ValidateQuizExamAnswers.propTypes = {
  score: PropTypes.number,
  passingPercentage: PropTypes.number,
  questions: PropTypes.array,
  retryExam: PropTypes.func,
  isRetrying: PropTypes.bool,
  reviewQuestions: PropTypes.func,
  closePanel: PropTypes.func,
}

export default ValidateQuizExamAnswers
